import styles from "./FullPageErrorState.module.css";

function ErrorIcon({ className }: { className?: string }) {
	return (
		<svg
			className={className}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
			<line
				x1="12"
				y1="8"
				x2="12"
				y2="13"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<circle cx="12" cy="16.5" r="1" fill="currentColor" />
		</svg>
	);
}

interface FullPageErrorStateProps {
	titleKey: string;
	descriptionKey: string;
	retryKey?: string;
	onRetry: () => void;
	t: (key: string) => string;
}

export function FullPageErrorState({
	titleKey,
	descriptionKey,
	retryKey = "error.retry",
	onRetry,
	t,
}: FullPageErrorStateProps) {
	return (
		<div className={styles.errorContainer} role="alert">
			<ErrorIcon className={styles.errorIcon} />
			<h2 className={styles.errorTitle}>{t(titleKey)}</h2>
			<p className={styles.errorDescription}>{t(descriptionKey)}</p>
			<button type="button" className={styles.retryButton} onClick={onRetry}>
				{t(retryKey)}
			</button>
		</div>
	);
}
